import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, SelectProps, Space, Tooltip, Modal, DatePicker } from "antd";
import { useParams } from "react-router-dom";
import HTTPService from "../../../utils/makerequest";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { IPageProps } from "../../../interfaces/page-data";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";
import { IInventory } from "../../../interfaces/IItemData";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, UnorderedListOutlined } from "@ant-design/icons";
import moment from "moment";
import { Box, Tab, Tabs } from "@material-ui/core";
import LaborTask from "./Modal/LaborTask";
import AddActivityName from "./AddActivityName";
import { Toast } from 'primereact/toast';
import { SyncOutlined, CloseOutlined } from "@ant-design/icons";
import Dropdown from "../../../AltisComponent/Dropdown";
import { IUser } from "../../../interfaces/IUser";

const UpdateCare: React.FunctionComponent<IPageProps> = (props) => {
  const { maintenanceId } = useParams<any>();
  const [careData, setCareData] = useState<any>();
  const [companyData, setCompanyData] = useState<ICompanyData[]>();
  const [inventoryData, setInventoryData] = useState<IInventory>();
  const [selectedCompany, setSelectedCompany] = useState<number | undefined>(undefined);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [maintenanceType, setMaintenanceType] = useState<number>();
  const [activityData, setActivityData] = useState<any>();
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedActivityType, setSelectedActivityType] = useState<number | undefined>(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showCustomFrequency, setShowCustomFrequency] = useState(false);
  const [customFrequency, setCustomFrequency] = useState<number>();
  const [calculatedDates, setCalculatedDates] = useState<string[]>([]);
  const [repeatMaintenanceDetail, setRepeatMaintenanceDetail] = useState<string[]>([]);
  const [isModalVisibleCare, setIsModalVisibleCare] = useState(false);
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const toast = useRef<Toast>(null);
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [selectedActivity, setSelectedActivity] = useState<number | undefined>(form.getFieldValue('activityId'));
  const [userData, setUserData] = useState<IUser[]>();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  useEffect(() => {
    InventoryFilter();
    getCareId(maintenanceId);
    getUserData(userInfo?.companyId);
    fetchData();
    if (userInfo?.companyId) {
      fetchActivity(userInfo.companyId);
    }
  }, []);

  useEffect(() => {
    if (careData?.maintenanceDetailTBL) {
      const dates = careData.maintenanceDetailTBL.map(detail =>
        moment(detail.dates).format('DD.MM.YYYY')
      );
      setCalculatedDates(dates);
    }
  }, [careData]);

  const getUserData = (companyId: number) => {
    HTTPService.GET(`/User/allUserName?companyId=${companyId}`)
      .then((res) => {
        if (!res.data) {
          return;
        }
        if (res.status === 200) {
          setUserData(res.data);
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: res.error.message,
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  };


  const onChangeHandler = (value: number) => {
    setSelectedActivityType(value);
    setShowCustomFrequency(value === -1);

    const currentRepeatCount = form.getFieldValue('repeatCount');
    const startDate = moment(careData?.maintenanceStartDate);

    if (!startDate || !currentRepeatCount) return;

    if (value !== -1) {
      let baseValue = 0;
      switch (value) {
        case 0: baseValue = 0; break;  // Tek seferlik
        case 1: baseValue = 1; break;  // Günlük
        case 7: baseValue = 7; break;  // Haftalık
        case 30: baseValue = 30; break; // Aylık
        case 365: baseValue = 365; break; // Yıllık
        default: baseValue = 0;
      }

      const newDates = [];
      let currentDate = moment(startDate);

      for (let i = 0; i < currentRepeatCount; i++) {
        if (i === 0) {
          newDates.push({
            maintenanceDetailId: i + 1,
            maintenanceId: careData?.maintenanceId,
            dates: currentDate.format('YYYY-MM-DD'),
            maintenanceTBL: null,
            inventoryTBL: null,
          });
        } else {
          currentDate = moment(startDate).add(i * baseValue, 'days');
          newDates.push({
            maintenanceDetailId: i + 1,
            maintenanceId: careData?.maintenanceId,
            dates: currentDate.format('YYYY-MM-DD'),
            maintenanceTBL: null,
            inventoryTBL: null,
          });
        }
      }

      // Hesaplanan yeni tarihleri state'e kaydet
      setCareData(prevData => ({
        ...prevData,
        maintenanceDetailTBL: newDates
      }));

      // Tarihleri görüntülemek için format değiştir
      const formattedDates = newDates.map(detail =>
        moment(detail.dates).format('DD.MM.YYYY')
      );
      setCalculatedDates(formattedDates);
    }
  };

  // Custom hesaplama için yeni fonksiyon ekle
  const handleCustomCalculation = () => {
    const frequency = form.getFieldValue('frequency');
    const repeatCount = form.getFieldValue('repeatCount');
    const startDate = moment(careData?.maintenanceStartDate);

    if (startDate && frequency && repeatCount) {
      calculateAndSetDates(startDate, frequency, repeatCount);
    }
  };

  // Hesaplama fonksiyonunu düzenle
  const calculateAndSetDates = (startDate: moment.Moment, interval: number, count: number) => {
    const newDates = [];
    let currentDate = moment(startDate);

    for (let i = 0; i < count; i++) {
      if (i === 0) {
        newDates.push({
          maintenanceDetailId: i + 1,
          maintenanceId: careData?.maintenanceId,
          dates: currentDate.format('YYYY-MM-DD'),
          maintenanceTBL: null,
          inventoryTBL: null,
        });
      } else {
        currentDate = moment(startDate).add(i * interval, 'days');
        newDates.push({
          maintenanceDetailId: i + 1,
          maintenanceId: careData?.maintenanceId,
          dates: currentDate.format('YYYY-MM-DD'),
          maintenanceTBL: null,
          inventoryTBL: null,
        });
      }
    }

    setCareData(prevData => ({
      ...prevData,
      maintenanceDetailTBL: newDates
    }));

    const formattedDates = newDates.map(detail => moment(detail.dates).format('DD.MM.YYYY'));
    setCalculatedDates(formattedDates);
  };


  const fetchData = async () => {
    const result = await HTTPService.GETCompanyNames();
    setCompanyData(result);
  };

  const getCareId = (maintenanceId: number) => {
    HTTPService.GET(`/Maintenance/MaintenanceById?maintenanceId=${maintenanceId}`)
      .then((res) => {
        if (res.status === 200 && res.data) {

          const uniqueRecords = res.data.repeatMaintenanceTBL.reduce((acc, current) => {
            const barcode = current?.inventoryTBL?.barcode;
            const exists = acc.find(item => item?.inventoryTBL?.barcode === barcode);

            if (!exists && barcode) {
              acc.push(current);
            }
            return acc;
          }, []);

          const uniqueDates = res.data.maintenanceDetailTBL.reduce((acc, current) => {
            const dateStr = moment(current.dates).format('YYYY-MM-DD');
            const exists = acc.find(item =>
              moment(item.dates).format('YYYY-MM-DD') === dateStr
            );

            if (!exists) {
              acc.push({
                ...current,
                dates: dateStr
              });
            }
            return acc;
          }, []);

          setSelectedActivity(res.data.activityId);
          setSelectedActivityType(res.data.repeatMaintenanceTBL[0].repeatMaintenance);

          setCareData({
            ...res.data,
            repeatMaintenanceTBL: uniqueRecords,
            maintenanceDetailTBL: uniqueDates
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t('error_fetching_data'),
            life: 3000
          });
        }
      })
      .catch((error) => {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('error_fetching_data'),
          life: 3000
        });
      });
  };

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role !== UserRole.Admin
      ? [
        {
          title: t('Company Name'),
          key: 'companyName',
          placeHolder: t('Company Name'),
          isSorting: true,
        },
      ]
      : []),
    {
      title: t('inventoryName'),
      headerAlign: 'center',
      align: 'left',
      key: 'inventoryName',
      placeHolder: t('inventoryName'),
      width: 250
    },
    {
      title: t('barcode'),
      isSorting: true,
      key: 'barcode',
      placeHolder: t('barcode'),
      width: 250
    },
    {
      title: t('item_type'),
      isSorting: true,
      key: 'typeName',
      placeHolder: t('item_type'),
      width: 250
    },
    {
      title: t('item_group'),
      isSorting: true,
      key: 'categoryName',
      placeHolder: t('item_group'),
      width: 250
    },
    {
      title: t('location'),
      isSorting: true,
      key: 'locationName',
      placeHolder: t('actualLocation'),
      width: 250,
      render: (text, record) => (
        <div>
          <span>{text}</span>
          {record.locationName !== record.actualLocationName && (
            <Tooltip title={record.actualLocationName}>
              <span style={{ color: 'red', marginLeft: 8, cursor: 'pointer' }}>⚠️</span>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: t('inventory_status_name'),
      isSorting: true,
      key: 'inventoryStatusName',
      placeHolder: t('inventory_status_name'),
      width: 250
    },
  ];

  const columns1: IMUIDataGridColumns[] = [
    {
      title: t('inventoryName'),
      headerAlign: 'center',
      align: 'left',
      key: 'inventoryName',
      placeHolder: t('inventoryName'),
      width: 485,
      render: (text, record) => record?.inventoryTBL?.inventoryName
    },
    {
      title: t('barcode'),
      isSorting: true,
      key: 'barcode',
      placeHolder: t('barcode'),
      width: 490,
      render: (text, record) => record?.inventoryTBL?.barcode
    },
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('Operations'),
      isSorting: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Space>
            <Popconfirm
              title={t('confirm_delete')}
              onConfirm={() => handleDeleteItem(record.inventoryId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')} placement="top">
                <Button
                  size="small"
                  icon={<DeleteOutlined />}
                  style={{
                    display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                    width: '60px',
                    borderRadius: '70px'
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              </Tooltip>
            </Popconfirm>
          </Space>
        </div>
      ),
    }
  ];

  const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
    return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
  };

  const InventoryFilter = (e?) => {
    const body = {
      pageSize: e?.pageSize || 10,
      page: e?.page || 1,
      barcode: e?.barcode,
      departmentName: e?.departmentName,
      inventoryName: e?.inventoryName,
      inventoryStatusName: e?.inventoryStatusName,
      typeName: e?.typeName,
      debtFirstName: e?.debtFirstName,
      debtLastName: e?.debtLastName,
      companyId: e?.companyId,
      companyName: e?.companyName,
      itemName: e?.itemName,
      itemGroup: e?.itemGroup,
      locationName: e?.locationName,
      categoryName: e?.categoryName,
      debbit: e?.debbit,
      responsible: e?.responsible,
      isPrinted: e?.isPrinted,
    };

    HTTPService.POST(`/Inventory/filters`, body).then((response) => {
      if (response.status === 200 && response.data) {
        setInventoryData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const handleAddSelectedItems = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: t('Warning'),
        detail: t('no_items_selected'),
        life: 3000
      });
      return;
    }

    setCareData(prev => {
      const existingItems = prev?.repeatMaintenanceTBL || [];
      const existingIds = new Set(existingItems.map(item => item.inventoryId));
      const newItems = selectedRows
        .filter(item => !existingIds.has(item.inventoryId))
        .map(item => ({
          inventoryId: item.inventoryId,
          inventoryTBL: {
            inventoryName: item.inventoryName,
            barcode: item.customBarcode || item.barcode
          }
        }));

      if (newItems.length === 0) {
        toast.current?.show({
          severity: 'warn',
          summary: t('info'),
          detail: t('alreadyExists'),
          life: 3000
        });
        return prev;
      }

      const updated = {
        ...prev,
        repeatMaintenanceTBL: [...existingItems, ...newItems],
        count: (existingItems.length + newItems.length)
      };

      toast.current?.show({
        severity: 'success',
        summary: t('success'),
        detail: t('assetAdd'),
        life: 3000
      });

      return updated;
    });

    setSelectedRows([]);
  };

  const handleRowSelection = (newSelection: any[]) => {
    setSelectedRows(newSelection);
  };

  const handleDeleteItem = (inventoryId: number) => {
    if (!careData?.repeatMaintenanceTBL) return;

    const updatedRepeatMaintenanceTBL = careData.repeatMaintenanceTBL.filter(
      item => item.inventoryId !== inventoryId
    );

    setCareData(prevState => {
      const newState = {
        ...prevState,
        repeatMaintenanceTBL: updatedRepeatMaintenanceTBL
      };

      return newState;
    });

    toast.current?.show({
      severity: 'success',
      summary: t('successful'),
      detail: t('inventory_delete'),
      life: 3000
    });
  };

  const updateCare = (formData) => {
    try {
      if (!careData?.repeatMaintenanceTBL || careData.repeatMaintenanceTBL.length === 0) {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('please_select_inventory'),
          life: 3000
        });
        return;
      }

      const finishDate = moment(careData?.maintenanceFinishDate);
      const maintenanceDetailTBL = careData?.maintenanceDetailTBL || [];

      if (finishDate && maintenanceDetailTBL.length > 0) {
        const invalidDates = maintenanceDetailTBL.some(detail => {
          const maintenanceDate = moment(detail.dates);
          return maintenanceDate.isAfter(finishDate, 'day');
        });

        if (invalidDates) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t('invalid_repeat_count_for_date_range', {
              endDate: finishDate.format('DD.MM.YYYY')
            }),
            life: 5000
          });
          return;
        }
      }

      const inventoryIds = careData.repeatMaintenanceTBL.map(item => item.inventoryId);
      const dates = careData?.maintenanceDetailTBL?.map(detail => detail.dates);

      const updateData = {
        inventoryId: inventoryIds,
        maintenanceId: parseInt(maintenanceId),
        companyId: formData.companyId || userInfo.companyId,
        activityId: selectedActivity,
        description: formData.description,
        maintenanceExternalResponsibleName: formData.maintenanceExternalResponsibleName,
        maintenanceExternalResponsibleMail: formData.maintenanceExternalResponsibleMail,
        maintenanceResponsibleUserId: formData.maintenanceResponsibleUserId,
        maintenanceStartDate: formData.maintenanceStartDate
          ? moment(formData.maintenanceStartDate).format('YYYY-MM-DDTHH:mm:ss')
          : careData?.maintenanceStartDate,
        maintenanceFinishDate: formData.maintenanceFinishDate
          ? moment(formData.maintenanceFinishDate).format('YYYY-MM-DDTHH:mm:ss')
          : careData?.maintenanceFinishDate,
        maintenanceType: 1,
        repeatMaintenance: selectedActivityType,
        maintenanceResponsible: formData.maintenanceResponsible,
        priority: Number(formData.priority),
        dates: dates
      };

      HTTPService.PUT(`/Maintenance/updateMaintenance`, updateData)
        .then((res) => {
          if (res.status === 200) {
            toast.current?.show({
              severity: 'success',
              summary: t('successful'),
              detail: t('update_success'),
              life: 3000
            });
            window.location.replace("/admin/care-management");
          } else {
            throw new Error(res.data?.message || t('update_failed'));
          }
        })
        .catch((error) => {
          console.error('Update Error:', error);
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: error.message || t('update_failed'),
            life: 3000
          });
        });
    } catch (error) {
      console.error('Form processing error:', error);
      toast.current?.show({
        severity: 'error',
        summary: t('errors'),
        detail: t('update_failed'),
        life: 3000
      });
    }
  };


  const handleCancel = () => {
    window.location.replace("/admin/care-management/");
  };

  const showModal = () => {
    setIsModalVisible(true);
    InventoryFilter();
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const getRepeatActivityValue = (repeatMaintenance?: number) => {
    if (repeatMaintenance === undefined || repeatMaintenance === null) {
      return undefined;
    }

    const standardValues = [0, 1, 7, 30, 365];

    if (standardValues.includes(repeatMaintenance)) {
      return repeatMaintenance;
    }

    return -1;
  };

  const fetchActivity = async (companyId: number) => {
    try {
      const result = await HTTPService.GETActivityNames(companyId);
      setActivityData(result);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: 'error',
        summary: t('errors'),
        detail: t('error_message'),
        life: 3000
      });
    }
  };


  const handleChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };


  const handleMaintenanceTypeChange = (value: number) => {
    setMaintenanceType(value);

    setCareData(prevData => ({
      ...prevData,
      maintenanceType: value
    }))

    if (value === 2) {
      form.setFieldsValue({
        maintenanceStartDate: null,
        maintenanceFinishDate: null,
        repeatActivity: null
      });
    }
  };

  const getMaintenanceTypeValue = (maintenanceType: number) => {
    return maintenanceType === 1 ? 1 : 2;
  };


  const calculateDates = (startDate: moment.Moment, repeatValue: number, repeatCount: number) => {
    const dates: string[] = [];
    const isoDates: string[] = [];
    let currentDate = moment(startDate);

    dates.push(currentDate.format('DD.MM.YYYY'));
    isoDates.push(currentDate.format('YYYY-MM-DD'));

    for (let i = 1; i < repeatCount; i++) {
      currentDate = moment(currentDate).add(repeatValue, 'days');
      dates.push(currentDate.format('DD.MM.YYYY'));
      isoDates.push(currentDate.format('YYYY-MM-DD'));
    }

    setRepeatMaintenanceDetail(isoDates);
    return dates;
  };


  const handleRepeatCountChange = (e: any) => {
    const value = e.target.value.trim();
    if (!value) {
      form.setFieldsValue({ repeatCount: undefined });
      return;
    }

    const newCount = Number(value);
    const startDate = moment(careData?.maintenanceStartDate);
    const repeatType = selectedActivityType;

    if (startDate && repeatType && newCount) {
      let baseValue = 0;
      switch (repeatType) {
        case 0: baseValue = 0; break;      // Tek seferlik
        case 1: baseValue = 1; break;      // Günlük
        case 7: baseValue = 7; break;      // Haftalık
        case 30: baseValue = 30; break;    // Aylık
        case 365: baseValue = 365; break;  // Yıllık
        case -1:
          baseValue = Number(form.getFieldValue('frequency'));
          break;
        default: baseValue = 0;
      }

      const newDates = [];
      let i = 0;
      let currentDate = moment(startDate);

      while (i < newCount) {
        newDates.push({
          maintenanceDetailId: i + 1,
          maintenanceId: careData?.maintenanceId,
          dates: currentDate.format('YYYY-MM-DD'),
          maintenanceTBL: null,
          inventoryTBL: null,
        });
        i++;
        currentDate = moment(startDate).add(i * baseValue, 'days');
      }

      setCareData(prevData => ({
        ...prevData,
        maintenanceDetailTBL: newDates
      }));

      const formattedDates = newDates.map(detail => moment(detail.dates).format('DD.MM.YYYY'));
      setCalculatedDates(formattedDates);
    }

    form.setFieldsValue({ repeatCount: newCount });
  };


  const showModalCare = () => {
    setIsModalVisibleCare(true);
  };


  const handleCancelCare = () => {
    setIsModalVisibleCare(false);
  };


  const savedNewCare = async (newActivity: any) => {
    try {
      setActivityData(prevData => {
        const updatedData = prevData ? [...prevData] : [];
        updatedData.push(newActivity);
        return updatedData;
      });

      form.setFieldValue('activityId', newActivity.activityId);
      setSelectedActivity(newActivity.activityId);

      setIsModalVisibleCare(false);

      toast.current?.show({
        severity: 'success',
        summary: t('successful'),
        detail: t('activity_added_successfully'),
        life: 3000
      });
    } catch (error) {
      console.error('Error saving activity:', error);
      toast.current?.show({
        severity: 'error',
        summary: t('errors'),
        detail: t('error_saving_activity'),
        life: 3000
      });
    }
  };

  const calculatedDatesStyles = {
    container: {
      marginBottom: '20px',
      padding: '10px',
      border: '1px solid #d9d9d9',
      borderRadius: '5px',
      backgroundColor: '#fafafa'
    },
    header: {
      marginBottom: '8px',
      fontWeight: 'bold',
      color: '#1890ff'
    },
    dateRow: {
      marginBottom: '4px',
      padding: '4px 8px',
      borderRadius: '4px'
    }
  };

  const handlePriorityChange = (value: number) => {
    form.setFieldsValue({ priority: value });
  };

  const responsibleOptions = React.useMemo(() => {
    if (!userData) return [];
    const exists = userData.some(u => u.displayName === careData?.maintenanceExternalResponsibleName);
    if (careData?.maintenanceExternalResponsibleName && !exists) {
      // careData'daki isim userData'da yoksa ekle
      return [
        ...userData,
        {
          userId: careData.maintenanceResponsibleUserId ?? careData.maintenanceExternalResponsibleName,
          displayName: careData.maintenanceExternalResponsibleName,
          userEmail: careData.maintenanceExternalResponsibleMail,
        }
      ];
    }
    return userData;
  }, [userData, careData]);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={updateCare}
      fields={[
        {
          name: ["activityId"],
          value: careData?.activityId
        },
        { name: ["description"], value: careData?.description },
        { name: ["priority"], value: careData?.priority },
        { name: ["maintenanceExternalResponsibleName"], value: careData?.maintenanceExternalResponsibleName },
        { name: ["maintenanceExternalResponsibleMail"], value: careData?.maintenanceExternalResponsibleMail },
        { name: ["maintenanceStartDate"], value: moment(careData?.maintenanceStartDate) },
        { name: ["maintenanceFinishDate"], value: moment(careData?.maintenanceFinishDate) },
        { name: ["repeatCount"], value: careData?.maintenanceDetailTBL?.length },
        {
          name: ["repeatActivity"],
          value: selectedActivityType !== undefined
            ? getRepeatActivityValue(selectedActivityType)
            : undefined
        },
        { name: ["maintenanceType"], value: getMaintenanceTypeValue(careData?.maintenanceType) }
      ]}
    >
      <Toast ref={toast} />
      <Card style={{ padding: "50px" }}>
        <h3>{t('updateCare')}</h3>

        <Box sx={{ width: "100%", marginBottom: 2, display: 'flex', justifyContent: 'flex-start' }}>
          <Tabs value={tabIndex} onChange={handleChange} centered>
            <Tab label={t("general")} />
            <Tab label={t('laborTask')} />
          </Tabs>
        </Box>

        <br></br>

        {tabIndex === 0 && (
          <Box>
            {userInfo?.role === UserRole.AltisAdmin && (
              <Form.Item
                name="companyId"
                label={t('Select company')}
                rules={[{ required: true, message: t('please_select_a_company') }]}
              >
                <Select showSearch placeholder={t('company_name')} style={{ marginBottom: '6px' }} filterOption={filterOption}>
                  {companyData?.map((company) => (
                    <Select.Option key={company.companyId} value={company.companyId}>
                      {company.companyName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Form.Item
              name='activityId'
              label={
                <Tooltip title={t('activity_name')}>
                  {t('activity_name')}
                </Tooltip>
              }
              rules={[{ required: true, message: t('activity_name') }]}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Select
                  placeholder={t('activity_name')}
                  style={{ flex: 1 }}
                  dropdownStyle={{ minWidth: 300 }}
                  filterOption={filterOption}
                  showSearch
                  value={selectedActivity}
                  onChange={(value) => {
                    setSelectedActivity(value);
                    form.setFieldsValue({ activityId: value });
                  }}
                >
                  {activityData?.map(row => (
                    <Select.Option key={row.activityId} value={row.activityId}>
                      {row.activityName}
                    </Select.Option>
                  ))}
                </Select>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={showModalCare}
                />
              </div>
            </Form.Item>

            <Modal
              visible={isModalVisibleCare}
              footer={null}
              onCancel={handleCancelCare}
              width={790}
              bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
            >
              <div style={{ flex: 1 }}>
                <AddActivityName
                  cancelModal={handleCancelCare}
                  savedObj={savedNewCare}
                  companyId={selectedCompany}
                  activityName={careData?.activityName}
                  onSetPage={props.onSetPage}
                  getPageData={props.getPageData}
                />
              </div>
            </Modal>

            {(careData?.maintenanceType || maintenanceType) === 1 && (
              <>
                <Form.Item
                  label={t('activity_start_date')}
                  name="maintenanceStartDate"
                  rules={[{ required: true, message: t('select_date_time') }]}
                >
                  <DatePicker
                    showTime
                    disabled
                    format="DD-MM-YYYY HH:mm"
                    placeholder={t('select_date_time')}
                    style={{ borderRadius: '5px', width: '100%' }}
                  />
                </Form.Item>

                <Form.Item
                  label={t('activity_finish_date')}
                  name="maintenanceFinishDate"
                  rules={[{ required: true, message: t('select_date_time') }]}
                >
                  <DatePicker
                    showTime
                    disabled
                    format="DD-MM-YYYY HH:mm"
                    placeholder={t('select_date_time')}
                    style={{ borderRadius: '5px', width: '100%' }}
                  />
                </Form.Item>
              </>

            )}

            <Form.Item
              name="priority"
              label={t('Priority')}
              rules={[{ required: true, message: t('Priority') }]}
            >
              <Select
                placeholder={t('Priority')}
                style={{ marginBottom: '6px' }}
                onChange={handlePriorityChange}
              >
                <Select.Option value={0}>{t('Low')}</Select.Option>
                <Select.Option value={1}>{t('Medium')}</Select.Option>
                <Select.Option value={2}>{t('High')}</Select.Option>
                <Select.Option value={3}>{t('Highest')}</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              label={t('description_activity')}
              name="description"
              rules={[{ required: true, message: t('enter_description') }]}
            >
              <Input placeholder={t('enter_description')} style={{ borderRadius: '5px' }} />
            </Form.Item>

            <Form.Item
              label={t('maintenanceResponsible')}
              name="maintenanceExternalResponsibleName"
              rules={[{ required: true, message: t('maintenanceResponsible') }]}
            >
              <Dropdown
                placeholder={t('maintenanceResponsible')}
                dataSource={responsibleOptions}
                allowCustomValue={true}
                valueKey="userId"
                style={{ width: '100%' }}
                includeEmptyOption={false}
                labelKey="displayName"
                onChange={(value) => {
                  const selectedUser = userData?.find(u => u.displayName === value || u.userId === value);
                  form.setFieldsValue({
                    maintenanceExternalResponsibleName: selectedUser ? selectedUser.displayName : value,
                    maintenanceResponsibleUserId: selectedUser ? selectedUser.userId : null,
                    maintenanceExternalResponsibleMail: selectedUser?.userEmail || undefined
                  });
                }}
              />
            </Form.Item>


            <Form.Item name="maintenanceResponsibleUserId" hidden>
              <Input type="hidden" />
            </Form.Item>

            <Form.Item
              label={t('email')}
              name="maintenanceExternalResponsibleMail"
              rules={[{ required: true }]}
            >
              <Dropdown
                placeholder={t('email')}
                dataSource={userData}
                valueKey="userEmail"
                labelKey="userEmail"
                style={{ width: '100%' }}
                includeEmptyOption={false}
                allowCustomValue={true}
              />
            </Form.Item>


            {(careData?.maintenanceType || maintenanceType) === 1 && (
              <>
                <Form.Item
                  label={t('repeat_activity')}
                  rules={[{ required: true, message: t('repeat_activity') }]}
                >
                  <Select
                    showSearch
                    placeholder={t('repeat_activity')}
                    onChange={onChangeHandler}
                    value={getRepeatActivityValue(selectedActivityType)}
                  >
                    <Select.Option value={0}>{t('onetime')}</Select.Option>
                    <Select.Option value={1}>{t('daily')}</Select.Option>
                    <Select.Option value={7}>{t('weekly')}</Select.Option>
                    <Select.Option value={30}>{t('monthly')}</Select.Option>
                    <Select.Option value={365}>{t('yearly')}</Select.Option>
                    <Select.Option value={-1}>{t('custom')}</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="repeatCount"
                  label={t('repeat_count')}
                  rules={[
                    { required: true, message: t('please_enter_repeat_count') },
                    { pattern: /^[0-9]*$/, message: t('please_enter_valid_number') }
                  ]}
                >
                  <Input
                    placeholder={t('enter_repeat_count')}
                    style={{ borderRadius: '5px' }}
                    type="number"
                    min={1}
                    onChange={handleRepeatCountChange}
                  />
                </Form.Item>

                {showCustomFrequency && (
                  <Form.Item
                    name="frequency"
                    label={t('frequency_days')}
                    rules={[
                      { required: true, message: t('days') },
                      { pattern: /^[0-9]*$/, message: t('please_enter_valid_number') }
                    ]}
                  >
                    <Input
                      placeholder={t('days')}
                      style={{ borderRadius: '5px' }}
                      type="number"
                      min={1}
                      onChange={() => handleCustomCalculation()}
                    />
                  </Form.Item>
                )}

                {calculatedDates.length > 0 && (
                  <div style={calculatedDatesStyles.container}>
                    <div style={calculatedDatesStyles.header}>
                      {t('calculated_dates')}:
                    </div>
                    {calculatedDates.map((date, index) => (
                      <div
                        key={index}
                        style={{
                          ...calculatedDatesStyles.dateRow,
                          backgroundColor: index % 2 === 0 ? '#fff' : '#f5f5f5'
                        }}
                      >
                        {index + 1}. {date}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            <Button
              onClick={showModal}
              type="primary"
              style={{ marginTop: 10, marginRight: 10, borderRadius: '5px' }}
              icon={<UnorderedListOutlined />}
            >
              {t('first_datagrid')}
            </Button>

            <Modal
              title={t('first_datagrid')}
              visible={isModalVisible}
              onCancel={handleModalCancel}
              width={1200}
              footer={[
                <Button
                  key="add"
                  type="primary"
                  onClick={() => {
                    handleAddSelectedItems();
                    handleModalCancel();
                  }}
                >
                  {t('add_selected_items')}
                </Button>
              ]}
            >
              <MUIDatagrid
                data={inventoryData?.data}
                columns={columns}
                enableSelection={true}
                onSelectionChange={handleRowSelection}
                onChange={InventoryFilter}
                total={inventoryData?.total}
              />
            </Modal>

            <MUIDatagrid
              data={careData?.repeatMaintenanceTBL}
              columns={columns1}
              onChange={InventoryFilter}
              total={selectedItems.length}
            />

            <Form.Item>
              <Row gutter={[4, 4]} justify="end" align="middle">
                <Col xs={12} sm={4}>
                  <Button
                    block
                    onClick={handleCancel}
                    type="primary"
                    style={{
                      height: 64,
                      backgroundColor: 'transparent',
                      color: '#1890ff',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '0 10px',
                      border: 'none',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                      e.currentTarget.style.color = '#40a9ff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                      e.currentTarget.style.color = '#1890ff';
                    }}
                  >
                    <CloseOutlined style={{ fontSize: 20 }} />
                    <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                      {t('cancel')}
                    </span>
                  </Button>
                </Col>
                <Col xs={12} sm={4}>
                  <Button
                    block
                    htmlType="submit"
                    type="primary"
                    style={{
                      height: 64,
                      backgroundColor: 'transparent',
                      color: '#1890ff',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '0 10px',
                      border: 'none',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                      e.currentTarget.style.color = '#40a9ff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                      e.currentTarget.style.color = '#1890ff';
                    }}
                  >
                    <SyncOutlined style={{ fontSize: 20 }} />
                    <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                      {t('update')}
                    </span>
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Box>
        )}

        {tabIndex === 1 && (
          <Box>
            <LaborTask
              selectedActivityId={form.getFieldValue('activityId')}
              formItemStyle={{ marginBottom: '16px' }}
            />
          </Box>
        )}

      </Card>
    </Form >
  );
};

export default UpdateCare;
